import React from 'react';
import TreasuryOverviewAccountsTable from './TreasuryOverviewAccountsTable';

const TreasuryAccounts = () => {
    return (
        <div className=''>
            <h1 className='px-4 pt-[32px] lg:px-0 lg:pt-0 text-[20px] font-medium leading-[30px] text-ebony'>
                Accounts
            </h1>

            <div className='mt-[32px] view-add-transactions'>
                <TreasuryOverviewAccountsTable pageView/>
            </div>
        </div>
    );
};

export default TreasuryAccounts;
